import {createSliceForList} from '../helpers'

export const featuredMusicsSlice = createSliceForList({
    name: 'featuredMusics',
    reducers: {
        // findFeaturedMusics
        featuredMusicsFetched: (state, action) => {
            const {total, records} = action.payload;
            state.listLoading = false;
            state.error = null;
            state.records = records;
            state.total = total;
        },
        // featuredMusicsAdd
        featuredMusicsAdd: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
        },
        // deleteFeaturedMusic
        featuredMusicDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
        },
        // deleteFeaturedMusics
        featuredMusicsDeleted: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
        },
        // getFeaturedMusicById
        featuredMusicFetched: (state, action) => {
            state.actionsLoading = false;
            state.dataForEdit = action.payload;
            state.error = null;
        },
        // updateFeaturedMusicOrder
        featuredMusicOrderUpdated: (state, action) => {
            state.error = null;
            state.actionsLoading = false;
        }

    }
})
